import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular/lazy';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {provideHttpClient} from "@angular/common/http";
import {IonicStorageModule} from "@ionic/storage-angular";
import {MssInitService} from "./services/mss-init.service";
import {StaleBuildErrorHandler} from "./structure/errors/stale-build-error-handler";
import {CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {ComponentsModule} from "./components/components.module";
import {QuillModule} from 'ngx-quill';

import { register } from 'swiper/element/bundle';
export function registerSwiper() {
    return () => { register(); };
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({swipeBackEnabled: false}),
        AppRoutingModule,
        IonicStorageModule.forRoot(),
        ComponentsModule,
        QuillModule.forRoot({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    [{list: 'ordered'}, {list: 'bullet'}],
                    [{header: [1, 2, 3, false]}],
                    ['blockquote', 'link'],
                    ['clean'],
                ],
            },
        }),
    ],
    providers: [
        {provide: ErrorHandler, useClass: StaleBuildErrorHandler},
        {
            provide: APP_INITIALIZER,
            useFactory: (mssInitService: MssInitService) => (): Promise<any> => mssInitService.init(),
            deps: [MssInitService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: registerSwiper,
            multi: true
        },
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy
        },

        provideHttpClient()
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
}
